import * as React from 'react';

import { DemandRequest } from '../../../../components/Recommendations';
import { DemandRequestModalContainer } from '../DemandRequestModalContainer';
import { useDemandRequest } from './utils/useDemandRequest';

interface IRealtorDemandContainerProps {
  ref?: React.Ref<HTMLDivElement>;
}

export function RealtorDemandContainer({ ref }: IRealtorDemandContainerProps): React.JSX.Element {
  const { demandSteps, description, handleModalSubmit, isDemandModalOpen, mainAction, toggleOpenDemandModal } =
    useDemandRequest();

  return (
    <>
      <DemandRequest ref={ref} description={description} onActionClick={mainAction} />
      {isDemandModalOpen && (
        <DemandRequestModalContainer onClose={toggleOpenDemandModal} steps={demandSteps} onSubmit={handleModalSubmit} />
      )}
    </>
  );
}
